import { useState } from "react";
import ReactECharts from "echarts-for-react";
import { useTranslation } from "react-i18next";

export default function SalesOrdersReport() {
    const { t } = useTranslation();

    const [active, setActive] = useState({
        revenue: true,
        completed: true,
        canceled: true
    });

    const toggle = (key: string) => {
        setActive((prev: any) => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    const series: any[] = [];

    if (active.revenue) {
        series.push({
            name: t('overview_report.revenue'),
            type: "bar",
            yAxisIndex: 0,
            data: [0, 0, 0, 380000, 0, 20000, 0],
            itemStyle: { color: "#6366f1" },
            barWidth: 18
        });
    }

    if (active.completed) {
        series.push({
            name: t('overview_report.completed'),
            type: "bar",
            yAxisIndex: 1,
            data: [0, 0, 0, 2, 0, 2, 0],
            itemStyle: { color: "#22c55e" },
            barWidth: 18
        });
    }

    if (active.canceled) {
        series.push({
            name: t('overview_report.canceled'),
            type: "bar",
            yAxisIndex: 1,
            data: [0, 0, 0, 1, 0, 0, 0],
            itemStyle: { color: "#f59e0b" },
            barWidth: 18
        });
    }

    const option = {
        tooltip: {
            trigger: "axis"
        },

        grid: {
            left: 10,
            right: 10,
            top: 40,
            bottom: 0,
            containLabel: true
        },

        xAxis: {
            type: "category",
            data: [
                "2026-02-28",
                "2026-03-01",
                "2026-03-02",
                "2026-03-03",
                "2026-03-04",
                "2026-03-05",
                "2026-03-06"
            ],
            axisLabel: {
                rotate: 40,
                margin: 15
            }
        },

        yAxis: [
            {
                type: "value",
                name: t('overview_report.revenue'),
                position: "left",
                axisLabel: {
                    formatter: (v: number) => `${v / 1000}k`
                }
            },
            {
                type: "value",
                name: t('overview_report.other'),
                position: "right"
            }
        ],

        series
    };

    return (
        <div className="bg-white dark:bg-[#1f1f1f] rounded-xl p-5">

            <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-4">
                {t('overview_report.revenue_order_report')}
            </h3>

            <div className="flex gap-3 mb-4">

                <button
                    onClick={() => toggle("revenue")}
                    className={`px-3 py-1 rounded text-sm flex items-center gap-2
                    ${active.revenue
                            ? "bg-indigo-600 text-white"
                            : "bg-gray-200 dark:bg-[#2a2a2a]"}`}
                >
                    <span className="w-2 h-2 rounded bg-indigo-400"></span>
                    {t('overview_report.revenue')}
                </button>

                <button
                    onClick={() => toggle("completed")}
                    className={`px-3 py-1 rounded text-sm flex items-center gap-2
                    ${active.completed
                            ? "bg-green-600 text-white"
                            : "bg-gray-200 dark:bg-[#2a2a2a]"}`}
                >
                    <span className="w-2 h-2 rounded bg-green-400"></span>
                    {t('overview_report.completed')}
                </button>

                <button
                    onClick={() => toggle("canceled")}
                    className={`px-3 py-1 rounded text-sm flex items-center gap-2
                    ${active.canceled
                            ? "bg-[#3e91ab] text-white"
                            : "bg-gray-200 dark:bg-[#2a2a2a]"}`}
                >
                    <span className="w-2 h-2 rounded bg-yellow-400"></span>
                    {t('overview_report.canceled')}
                </button>

            </div>

            <ReactECharts
                option={option}
                notMerge={true}
                style={{ height: 350 }}
            />

        </div>
    );
}